module.exports = __webpack_public_path__ + "img/photo02.bdddf992.jpg";